import React from 'react';
import { Link } from 'react-router-dom';
import { BsYoutube, BsInstagram, BsFacebook } from 'react-icons/bs';

function NavbarBottom() {
  return (
    <nav
      className="hidden md:flex justify-between text-white w-full sticky z-50 top-0"
      style={{ backgroundColor: '#FF3C3C' }}
    >
      <div id="targetElement" className="px-4 xl:px-8 py-3 flex w-full items-center">
        {/* Menu tengah */}
        <ul className="hidden md:flex px-4 mx-auto font-semibold font-heading space-x-6 lg:space-x-8 pb-1 text-white text-sm lg:text-base">
          <li>
            <Link to="/homefo" className="hover:text-yellow-200 transition-colors duration-200">
              BERANDA
            </Link>
          </li>

          {/* PROFIL */}
          <li>
            <div className="group inline-block">
              <button className="outline-none focus:outline-none flex items-center min-w-[80px] group">
                <span className="pr-1 font-semibold flex-1 hover:text-yellow-200 transition-colors duration-200">
                  PROFIL
                </span>
                <svg
                  className="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-200 ease-in-out"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </button>
              <ul
                className="bg-[#FF3C3C] transform scale-0 group-hover:scale-100 absolute transition duration-200 ease-in-out origin-top min-w-[220px] rounded-lg shadow-lg border border-white/10 z-50"
                style={{ listStyleType: 'none', padding: '4px 0' }}
              >
                <li className="rounded-sm relative px-4 py-2 hover:bg-white/20 transition-colors duration-150 group/sub">
                  <button className="w-full text-left flex items-center outline-none focus:outline-none">
                    <span className="pr-1 flex-1 text-sm">KELEMBAGAAN JDIH</span>
                    <svg
                      className="fill-current h-4 w-4 transform group-hover/sub:rotate-90 transition duration-200 ease-in-out"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </button>
                  <ul className="bg-[#FF3C3C] border border-white/10 rounded-lg shadow-lg absolute top-0 left-full ml-1 transition duration-200 ease-in-out origin-top-left min-w-[220px] transform scale-0 group-hover/sub:scale-100 z-50">
                    <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                      <Link to="/struktur-organisasi">STRUKTUR ORGANISASI BAGIAN HUKUM</Link>
                    </li>
                    <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                      <Link to="/struktur-organisasi-jdih">STRUKTUR ORGANISASI JDIH KOTA MAGELANG</Link>
                    </li>
                    <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                      <Link to="/about">VISI & MISI</Link>
                    </li>
                  </ul>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/dasar-hukum">DASAR HUKUM</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/guest-book">KONTAK</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/sop-jdih">STANDAR OPERASIONAL PROSEDUR (SOP)</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/data-statistik">DATA STATISTIK</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/anggota-jdih">ANGGOTA JDIH</Link>
                </li>
              </ul>
            </div>
          </li>

          {/* BERITA */}
          <li>
            <div className="group inline-block">
              <button className="outline-none focus:outline-none flex items-center min-w-[80px] group">
                <span className="pr-1 font-semibold flex-1 hover:text-yellow-200 transition-colors duration-200">
                  BERITA
                </span>
                <svg
                  className="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-200 ease-in-out"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </button>
              <ul
                className="bg-[#FF3C3C] transform scale-0 group-hover:scale-100 absolute transition duration-200 ease-in-out origin-top min-w-[220px] rounded-lg shadow-lg border border-white/10 z-50"
                style={{ listStyleType: 'none', padding: '4px 0' }}
              >
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/berita/bantuanhukum">BANTUAN HUKUM DAN HAM</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/berita/dokumentasi">DOKUMENTASI INFORMASI DAN EVALUASI HUKUM</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/berita/perundangan">PERUNDANG-UNDANGAN</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/berita">SEMUA BERITA</Link>
                </li>
              </ul>
            </div>
          </li>

          {/* DOKUMEN HUKUM */}
          <li>
            <div className="group inline-block">
              <button className="outline-none focus:outline-none flex items-center min-w-[80px] group">
                <span className="pr-1 font-semibold flex-1 hover:text-yellow-200 transition-colors duration-200">
                  DOKUMEN HUKUM
                </span>
                <svg
                  className="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-200 ease-in-out"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </button>
              <ul
                className="bg-[#FF3C3C] transform scale-0 group-hover:scale-100 absolute transition duration-200 ease-in-out origin-top min-w-[220px] rounded-lg shadow-lg border border-white/10 z-50"
                style={{ listStyleType: 'none', padding: '4px 0' }}
              >
                <li className="rounded-sm relative px-4 py-2 hover:bg-white/20 transition-colors duration-150 group/sub">
                  <button className="w-full text-left flex items-center outline-none focus:outline-none">
                    <span className="pr-1 flex-1 text-sm">PRODUK HUKUM</span>
                    <svg
                      className="fill-current h-4 w-4 transform group-hover/sub:rotate-90 transition duration-200 ease-in-out"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </button>
                  <ul className="bg-[#FF3C3C] border border-white/10 rounded-lg shadow-lg absolute top-0 left-full ml-1 transition duration-200 ease-in-out origin-top-left min-w-[220px] transform scale-0 group-hover/sub:scale-100 z-50">
                    <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                      <Link to="/pencarian-produk-hukum/produk-hukum-cipta-kerja">PRODUK HUKUM CIPTA KERJA</Link>
                    </li>
                    <li className="rounded-sm relative px-4 py-2 hover:bg-white/20 transition-colors duration-150 group/sub2">
                      <button className="w-full text-left flex items-center outline-none focus:outline-none">
                        <span className="pr-1 flex-1 text-sm">PRODUK HUKUM PUSAT</span>
                        <svg
                          className="fill-current h-4 w-4 transform group-hover/sub2:rotate-90 transition duration-200 ease-in-out"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                        </svg>
                      </button>
                      <ul className="bg-[#FF3C3C] border border-white/10 rounded-lg shadow-lg absolute top-0 left-full ml-1 transition duration-200 ease-in-out origin-top-left min-w-[200px] transform scale-0 group-hover/sub2:scale-100 z-50">
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/undang-undang">UNDANG-UNDANG</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/peraturan-pemerintah">PERATURAN PEMERINTAH</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="rounded-sm relative px-4 py-2 hover:bg-white/20 transition-colors duration-150 group/sub2">
                      <button className="w-full text-left flex items-center outline-none focus:outline-none">
                        <span className="pr-1 flex-1 text-sm">PRODUK HUKUM DAERAH</span>
                        <svg
                          className="fill-current h-4 w-4 transform group-hover/sub2:rotate-90 transition duration-200 ease-in-out"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                        </svg>
                      </button>
                      <ul className="bg-[#FF3C3C] border border-white/10 rounded-lg shadow-lg absolute top-0 left-full ml-1 transition duration-200 ease-in-out origin-top-left min-w-[220px] transform scale-0 group-hover/sub2:scale-100 z-50">
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/peraturan-daerah">PERATURAN DAERAH</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/peraturan-wali-kota">PERATURAN WALIKOTA</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/keputusan-wali-kota">KEPUTUSAN WALIKOTA</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/keputusan-sekretaris-daerah">KEPUTUSAN SEKRETARIS DAERAH</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/instruksi-wali-kota">INSTRUKSI WALIKOTA</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/surat-edaran-wali-atau-wakil-kota">SURAT EDARAN WALI KOTA/WAKIL WALI KOTA</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/surat-edaran-sekretaris-daerah">SURAT EDARAN SEKRETARIS DAERAH</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="rounded-sm relative px-4 py-2 hover:bg-white/20 transition-colors duration-150 group/sub2">
                      <button className="w-full text-left flex items-center outline-none focus:outline-none">
                        <span className="pr-1 flex-1 text-sm">PRODUK HUKUM OPD</span>
                        <svg
                          className="fill-current h-4 w-4 transform group-hover/sub2:rotate-90 transition duration-200 ease-in-out"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                        </svg>
                      </button>
                      <ul className="bg-[#FF3C3C] border border-white/10 rounded-lg shadow-lg absolute top-0 left-full ml-1 transition duration-200 ease-in-out origin-top-left min-w-[220px] transform scale-0 group-hover/sub2:scale-100 z-50">
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/peraturan-kepada-opd">PERATURAN KEPALA OPD</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/keputusan-kepada-opd">KEPUTUSAN KEPALA OPD</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/keputusan-camat">KEPUTUSAN CAMAT</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/keputusan-lurah">KEPUTUSAN LURAH</Link>
                        </li>
                        <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                          <Link to="/pencarian-produk-hukum/surat-edaran-kepala-opd">SURAT EDARAN KEPALA OPD</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                      <Link to="/pencarian-produk-hukum/dokumen-hukum-langka">DOKUMEN LANGKA</Link>
                    </li>
                    <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                      <Link to="/pencarian-produk-hukum/perjanjian-kerjasama">DOKUMEN KERJASAMA</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>

          {/* DOKUMEN PEMBENTUKAN PUU */}
          <li>
            <div className="group inline-block">
              <button className="outline-none focus:outline-none flex items-center min-w-[80px] group">
                <span className="pr-1 font-semibold flex-1 hover:text-yellow-200 transition-colors duration-200">
                  DOKUMEN PEMBENTUKAN PUU
                </span>
                <svg
                  className="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-200 ease-in-out"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </button>
              <ul
                className="bg-[#FF3C3C] transform scale-0 group-hover:scale-100 absolute transition duration-200 ease-in-out origin-top min-w-[220px] rounded-lg shadow-lg border border-white/10 z-50"
                style={{ listStyleType: 'none', padding: '4px 0' }}
              >
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/pencarian-produk-hukum/propemperda">PROPEMPERDA</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/pencarian-produk-hukum/propemperkada">PROPEMPERKADA</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/pencarian-produk-hukum/naskah-akademik">NASKAH AKADEMIK</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/pencarian-produk-hukum/rancangan-peraturan-daerah">RANCANGAN PERATURAN DAERAH</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/pencarian-produk-hukum/rancangan-peraturan-walikota">RANCANGAN PERATURAN WALIKOTA</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/pencarian-produk-hukum/hasil-harmonisasi">HASIL HARMONISASI</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/pencarian-produk-hukum/hasil-fasilitasi-atau-evaluasi">HASIL FASILITASI ATAU EVALUASI</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/pencarian-produk-hukum/analisis-dan-evaluasi-hukum">ANALISIS DAN EVALUASI</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/pencarian-produk-hukum/kajian-produk-hukum">KAJIAN PRODUK HUKUM</Link>
                </li>
                <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                  <Link to="/pencarian-produk-hukum/risalah-pembahasan">RISALAH PEMBAHASAN</Link>
                </li>
              </ul>
            </div>
          </li>

          {/* LAYANAN HUKUM */}
          <li>
            <div className="group inline-block">
              <button className="outline-none focus:outline-none flex items-center min-w-[80px] group">
                <span className="pr-1 font-semibold flex-1 hover:text-yellow-200 transition-colors duration-200">
                  LAYANAN HUKUM
                </span>
                <svg
                  className="fill-current h-4 w-4 transform group-hover:-rotate-180 transition duration-200 ease-in-out"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </button>
              <ul
                className="bg-[#FF3C3C] transform scale-0 group-hover:scale-100 absolute transition duration-200 ease-in-out origin-top min-w-[220px] rounded-lg shadow-lg border border-white/10 z-50"
                style={{ listStyleType: 'none', padding: '4px 0' }}
              >
                <li className="rounded-sm relative px-4 py-2 hover:bg-white/20 transition-colors duration-150 group/sub">
                  <button className="w-full text-left flex items-center outline-none focus:outline-none">
                    <span className="pr-1 flex-1 text-sm">KONSULTASI HUKUM</span>
                    <svg
                      className="fill-current h-4 w-4 transform group-hover/sub:rotate-90 transition duration-200 ease-in-out"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </button>
                  <ul className="bg-[#FF3C3C] border border-white/10 rounded-lg shadow-lg absolute top-0 left-full ml-1 transition duration-200 ease-in-out origin-top-left min-w-[220px] transform scale-0 group-hover/sub:scale-100 z-50">
                    <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                      <a href="https://demo.siabah.magelangkota.go.id/" target="_blank" rel="noopener noreferrer">
                        SURVEY KEPUASAN MASYARAKAT
                      </a>
                    </li>
                    <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                      <a href="https://siabah.magelangkota.go.id/" target="_blank" rel="noopener noreferrer">
                        Sistem Informasi Bagian Hukum (SiABAH)
                      </a>
                    </li>
                    <li className="px-4 py-2 hover:bg-white/20 transition-colors duration-150 text-sm">
                      <a href="https://bo.jdih.magelangkota.go.id/katalog_download/jdih-app.apk" target="_blank" rel="noopener noreferrer">
                        Download Aplikasi JDIH
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
        </ul>

        {/* Ikon sosial media */}
        <div className="hidden lg:flex items-center space-x-3">
          <a href="#" className="text-white hover:text-yellow-200 transition-colors duration-200">
            <BsYoutube size={20} />
          </a>
          <a href="#" className="text-white hover:text-yellow-200 transition-colors duration-200">
            <BsInstagram size={20} />
          </a>
          <a href="#" className="text-white hover:text-yellow-200 transition-colors duration-200">
            <BsFacebook size={20} />
          </a>
        </div>
      </div>
    </nav>
  );
}

export default NavbarBottom;